// extracted by css-extract-rspack-plugin
export default {"container":"BannerTextGeneration-module__container--mF6UL"};